import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import TasksModule from '@modules/TasksModule';
import { setExternalCallToCompleted } from '../callHandlers/externalCalls';

function handleTaskComplete(
  context: InboxContext,
  task: ITask,
  classified: boolean,
): void {
  inboxActions.restorePrevSelectedTaskId();

  if (task.isInternal) {
    TasksModule.deleteTask(task.id);
    if (SoftPhoneModule.isInCall()) {
      SoftPhoneModule.endCall(task.id);
    }
  } else {
    setExternalCallToCompleted(context, task.id, classified);
  }
}

export default handleTaskComplete;
